import "./RequirementCard.css";
import Card from "./Card";
import IconText from "./IconText";

export default function RequirementCard({
  icon,
  iconElement,
  title,
  description,
  children,
  variant = "primary",
  accent = true,
  size = "md",
  className = "",
  bodyClassName = "",
}) {
  return (
    <Card
      variant="guideline"
      padding={size === "sm" ? "md" : "lg"}
      className={`ui-requirement-card ${accent ? `accent-${variant}` : ""} ${className}`}
    >
      {(title || description || icon || iconElement) && (
        <IconText
          icon={icon}
          iconElement={iconElement}
          title={title}
          description={description}
          variant={variant}
          size={size === "sm" ? "sm" : "md"}
          iconSize={size === "sm" ? 16 : 18}
          align="start"
        />
      )}

      {children && <div className={`ui-requirement-card-body ${bodyClassName}`}>{children}</div>}
    </Card>
  );
}
